import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';

import { IContext } from '../../../shared/store';
import { microfrontendsAPI } from '../microfrontendsAPI';

/**
 * Единая сборка браузерного контекста. Его получают и redux-стор (третьим аргументом thunk'ов),
 * и ApplicationContext.Provider — собирать их по отдельности нельзя, они разъезжаются.
 */
export function createContext(): IContext {
  return {
    config: getConfig(),
    httpApi: getHttpApi(),
    logger: getLogger(),
    microfrontendsAPI,
  };
}
